import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const deleteMilestone = createAsyncThunk(
  "initiatives/deleteMilestone",
  async (milestoneId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/milestones/${milestoneId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      if (!response.data?.success) {
        return rejectWithValue(response.data?.message || "Failed to delete milestone");
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete milestone");
    }
  }
);
